import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviousVesselSummaryComponent } from './previous-vessel-summary.component';
import { PreviousVesselSummaryRoutingModule } from './prvious-vessel-summary.routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomRadioButtonModule } from 'src/app/shared/components/custom-radio-button/custom-radio-button.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { ForceApprovePopupModule } from 'src/app/shared/components/force-approve-popup/force-approve-popup.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { PortRequestFormRoutingModule } from '../../port-request-form/port-request-form-routing.module';
import { MasterNewformRoutingModule } from '../master-newform-routing.module';



@NgModule({
  declarations: [
    PreviousVesselSummaryComponent
  ],
  imports: [
    CommonModule,
    PreviousVesselSummaryRoutingModule,
    CustomInputModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropdownModule,
    ExpansionPanelModule,
    CustomDatePickerModule,
    MaterialModule,
    ForceApprovePopupModule,
    MatPaginatorModule,
    CustomTimpickerModule,
    MatSortModule,
    MasterNewformRoutingModule,
    MaterialModule,
    CustomInputModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    CustomRadioButtonModule,
    ReactiveFormsModule,
    PortRequestFormRoutingModule
  ]
})
export class PreviousVesselSummaryModule { }
